"use client";
import { useState as t, useRef as R, useImperativeHandle as I } from "react";
import { useInkeepConfig as T } from "../../providers/config-provider.js";
import { useTransformResults as C } from "./transform-results.js";
import { useInstantUpdate as L } from "../../hooks/use-instant-update.js";
import { useCommandStore as k } from "../../atoms/cmdk/index.js";
const D = () => {
  const { searchSettings: u } = T(), { tabs: s, searchFunctionsRef: c } = u, [n, i] = t(!1), o = R(null), [r, l] = t(!1), a = s?.length ? typeof s[0] == "string" ? s[0] : s[0][0] : "All", [f, m] = t(a), [e, p] = t([]), d = C(e), { disableTransition: h, disabled: S } = L(), b = k();
  return I(c, () => ({
    updateQuery(g) {
      b.setState("search", g);
    },
    focusInput: () => {
      o.current?.focus();
    }
  })), {
    results: d,
    resultsList: e,
    setResultsList: p,
    hasContent: n && (e.length > 0 || r),
    loading: r,
    setLoading: l,
    defaultTab: a,
    tab: f,
    setTab: m,
    disableTransition: h,
    transitionsDisabled: S,
    inputRef: o,
    showSearchResults: n,
    setShowSearchResults: i
  };
};
export {
  D as useInkeepSearch
};
